import {ApiSortsDerived} from '@/api/meta/odata';
import {getDetailPicklist} from '@/api/module/picklist';
import Picklist, {ApiPicklist, DetailPicklistFilters} from '@/model/Picklist';
import {createVersionedStorage} from './types';

const useDetailPicklistStore = createVersionedStorage<
  DetailPicklistFilters,
  ApiSortsDerived<ApiPicklist>,
  Picklist | null
>('detailPicklist', {
  fetchFn: getDetailPicklist,
  defaultData: null,
  defaultFilters: {},
  defaultSorts: [],
});

export default useDetailPicklistStore;
